import { render, staticRenderFns } from "./OrderContact.vue?vue&type=template&id=126a071e&scoped=true&"
import script from "./OrderContact.vue?vue&type=script&lang=js&"
export * from "./OrderContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126a071e",
  null
  
)

export default component.exports